import * as React from 'react';
export const GDSvg = React.forwardRef(function GDSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
        transform: 'translate(0 2)',
      },
      /*#__PURE__*/ React.createElement('rect', {
        width: 16,
        height: 12,
        fill: '#E25950',
        rx: 2,
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        d: 'M2 2h12v8H2z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#159570',
        d: 'M14 2v8L8 6l6-4ZM2 2l6 4-6 4V2Zm2 3a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        fillRule: 'nonzero',
        d: 'M8 4a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        d: 'M8 5a1 1 0 1 1 0 2 1 1 0 0 1 0-2zM3.5 1a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0zm4 0a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0zm4 0a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0zm-8 10a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0zm4 0a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0zm4 0a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0z',
      }),
    ),
  );
});
GDSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var GD = {
  category: 'flag',
  colorable: false,
  name: 'GD',
  svg: GDSvg,
};
